import { BaseApiService } from './BaseApiService';

class ApiService extends BaseApiService {
  isTracingEnabled = false;
}

export default new ApiService();
